export var MemberSubscriptionStatus;
(function(MemberSubscriptionStatus) {
    MemberSubscriptionStatus[/**
     * The [[Member]] has access to the [[MemberSubscription]] and its benefits.
     */ "Active"] = "Active";
    MemberSubscriptionStatus[/**
     * The [[MemberSubscription]] is frozen, potentially due to failed billing attempts.
     *
     * @remarks
     * If due to failed billing attempts, then the [[Member]] needs to reactivate their [[MemberSubscription]] via a one-off payment of the
     * [[MemberSubscriptionBillingDetails.reactivationPrice]] to change the [[MemberSubscription.status]] back to [[Active]].
     */ "Frozen"] = "Frozen";
    MemberSubscriptionStatus[/**
     * The [[Member]] has put their [[MemberSubscription]] on hold,
     * so they won't have access to its benefits for an agreed [[MemberSubscriptionHoldPeriod]].
     */ "OnHold"] = "OnHold";
    MemberSubscriptionStatus[/**
     * The [[MemberSubscription]] has not yet started, so the [[Member]] does not have access to its benefits.
     */ "NotStarted"] = "NotStarted";
})(MemberSubscriptionStatus || (MemberSubscriptionStatus = {}));

//# sourceMappingURL=member-subscription-status.js.map